import './faq-accordion.scss';

/**
 * speed:               (ms) Speed of open / close Animation
 * breakPoint:          (In Pixel) From this breakpoint the Accordion will stop working
 * onlyOneActive:       (boolean) Only 1 Accordion should be opened at a time
 * activeClass:         (string) String of class will be placed at active/open Accordion Element
 * waitUntilClose:      (boolean) Will only work with "onlyOneActive"-Option. Should the new active Element open after the last opened Element be closed?
 * deactiveClass:       (string) String of class will be placed at closed/inactive Accordion Element
 */
import { YoutubePlayer } from '../../js/youtube-player';
import { getOffset, loadYoutubeApiPromise, smoothScrollTo } from '../../js/helper';
import axios from 'axios';

class FaqAccordion {
    constructor (element, options) {
        this.$accordionElement = element;
        this.$parent = element.parentElement;
        this.$checkbox = this.$parent.querySelector('input[type="checkbox"]');
        this.$label = this.$parent.querySelector('label');
        this.name = element.getAttribute('data-faq-accordion');
        this.wait = false;
        this.accordionActive = false;
        this.$accordionRoot = document.querySelector('[data-faq-accordion="' + this.name + '"]');
        this.$$faqVideos = this.$accordionElement.querySelectorAll('[data-faq-accordion-video]');
        this.isOpen = false;
        this.votingRunning = false;

        const settings = {
            speed: 500,
            onlyOneActive: true,
            waitUntilClose: false,
            activeClass: 'is--active',
            scrollAddition: 0,
            deactiveClass: null,
            breakPointMin: null
        };

        this.settings = Object.assign({}, settings, options);

        if (!this.$accordionRoot) {
            this.$accordionRoot = this.$parent.parentElement;
        }
    }

    initialize () {
        this.accordionActive = this.checkBreakPoint();
        if (this.$$faqVideos.length > 0) {
            const waitForConsent = setInterval(() => {
                if (typeof CookieConsent !== 'undefined') {
                    clearInterval(waitForConsent);
                    if (CookieConsent.consent.marketing === true) { // eslint-disable-line
                        loadYoutubeApiPromise().then((resolve) => {
                            this.initVideos();
                        });
                    } else {
                        if (this.$$faqVideos.length > 0) {
                            this.$$faqVideos.forEach((video) => {
                                this.showRestriction(video);
                            });
                        }
                    }
                } else {
                    console.log('waiting for CookieContent');
                }
            }, 300);

            // timout if cookie consent is not defined - to prevent a permanent loop in the terminal
            setTimeout(() => {
                clearInterval(waitForConsent);
            }, 10000);
        }
        this.setEvents();
    }

    removeRestriction (media) {
        if (media) {
            const $placeholder = media.parentElement.querySelector('.media__restriction');

            if ($placeholder) {
                $placeholder.remove();
            }
        }
    }

    showRestriction (media) {
        if (media) {
            const $placeholder = media.parentElement.querySelector('.media__restriction');

            if ($placeholder) {
                $placeholder.classList.add('is--shown');
            }
        }
    }

    setEvents () {
        if (this.settings.breakPointMin !== null) {
            window.addEventListener('resize', () => {
                this.accordionActive = this.checkBreakPoint();
            });
        }

        if (this.$checkbox && this.$label) {
            this.$label.addEventListener('click', (e) => {
                if (!this.$accordionRoot.classList.contains('is--waiting')) {
                    if (this.accordionActive) {
                        if (!this.wait) {
                            if (!this.$checkbox.checked) {
                                this.closeElement(this.settings.onlyOneActive, this.$checkbox.getAttribute('id'), () => {
                                    this.openElement();
                                });
                            } else {
                                this.closeElement();
                            }
                        } else {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                } else {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }

        this.$accordionElement.addEventListener('change', (event) => {
            if (event.target.getAttribute('type') === 'radio') {
                const $form = event.target.closest('form');

                if ($form && this.votingRunning === false) {
                    this.votingRunning = true;

                    if (event.target.value === '1') {
                        event.target.parentElement.querySelector('label[for="' + event.target.getAttribute('id') + '"]')?.classList.add('has--liked');
                    }

                    if (event.target.value === '0') {
                        event.target.parentElement.querySelector('label[for="' + event.target.getAttribute('id') + '"]')?.classList.add('has--unliked');
                    }
                    this.sendVoting($form);
                }
            }
        });
    }

    initVideos () {
        const loadVideoPlayer = () => {
            this.$$faqVideos.forEach((video) => {
                new YoutubePlayer(video, { // eslint-disable-line
                    onStart: (videoId) => {
                        video.parentElement.classList.add('is--playing');
                    },
                    onEnd: () => {
                        video.parentElement.classList.remove('is--playing');
                    }
                });

                this.removeRestriction(video);
            });
        };

        if (window.onYouTubeIframeAPIReady !== 'undefined') {
            loadVideoPlayer();
        } else {
            const waitInterval = setInterval(() => {
                if (window.onYouTubeIframeAPIReady !== 'undefined') {
                    loadVideoPlayer();
                    clearInterval(waitInterval);
                }
            });
        }
    }

    checkBreakPoint () {
        if (this.settings.breakPointMin !== null) {
            return window.innerWidth < this.settings.breakPointMin;
        } else {
            return true;
        }
    }

    closeElement (onlyOneActive, clickedID, callback) {
        let wait = false;

        if (onlyOneActive === true) {
            const $$activeElements = [].slice.call(document.querySelectorAll('[data-faq-accordion="input"]:checked'));

            $$activeElements.forEach((checkbox) => {
                const label = checkbox.nextElementSibling;

                if (label.classList.contains(this.settings.activeClass) && checkbox.getAttribute('id') !== clickedID) {
                    if (this.settings.waitUntilClose) {
                        wait = true;
                    }
                    label.click();
                }
            });

            if (typeof callback === 'function') {
                if (wait) {
                    setTimeout(() => {
                        callback();
                    }, this.settings.speed);
                } else {
                    callback();
                }
            }
        } else {
            if (this.$label.classList.contains(this.settings.activeClass)) {
                this.$accordionElement.style.height = this.$accordionElement.scrollHeight + 'px';
                this.wait = true;

                setTimeout(() => {
                    this.$accordionElement.style.height = '0px';
                    this.$label.classList.remove(this.settings.activeClass);

                    if (this.settings.deactiveClass !== null) {
                        this.$label.classList.add(this.settings.deactiveClass);
                    }
                }, 50);

                setTimeout(() => {
                    this.wait = false;
                }, this.settings.speed + 50);
            }

            if (typeof callback === 'function') {
                callback();
            }
        }
    }

    openElement () {
        this.wait = true;
        this.$accordionRoot.classList.add('is--waiting');
        this.$label.classList.add(this.settings.activeClass);

        if (this.settings.deactiveClass !== null) {
            this.$label.classList.remove(this.settings.deactiveClass);
        }

        this.$accordionElement.style.height = this.$accordionElement.scrollHeight + 'px';

        setTimeout(() => {
            this.$accordionElement.style.height = 'auto';
            this.wait = false;
            this.$accordionRoot.classList.remove('is--waiting');
        }, this.settings.speed);

        const scrollToEntry = (timeOutTiming, moveTiming, scrollAddition = 0) => {
            setTimeout(() => {
                const headerHeight = document.querySelector('[data-header="root"]')?.clientHeight || 0;
                let anchorMovement = getOffset(this.$accordionElement).top - headerHeight - 70;

                if (document.querySelector('[data-faq-section="root"]') && window.innerWidth < 1024) {
                    const navigationHeight = document.querySelector('.faq-section__navigation')?.clientHeight || 0;
                    anchorMovement = getOffset(this.$accordionElement).top - headerHeight - navigationHeight - 150;
                }

                smoothScrollTo(0, anchorMovement, moveTiming);
            }, timeOutTiming);
        };

        if (this.settings.waitUntilClose) {
            scrollToEntry(250, 100, this.settings.scrollAddition);
        }

        if (this.settings.onlyOneActive) {
            scrollToEntry(500, 100, this.settings.scrollAddition);
        }
    }

    sendVoting ($form) {
        axios({
            method: 'POST',
            url: $form.getAttribute('action'),
            data: new FormData($form)
        }).then((result) => {
            const $votings = $form.querySelector('.has--number');

            if ($votings) {
                if (result.data.success === true) {
                    const oldCount = parseInt($votings.innerText);
                    if (oldCount !== result.data.likeCount) {
                        $votings.innerText = result.data.likeCount;
                    }
                    $form.firstElementChild.classList.add('has--voted');
                } else {
                    console.warn('Error at voting');
                }
            }

            this.votingRunning = false;
        }).catch((error) => {
            this.votingRunning = false;
            throw Error(error);
        });
    }
}

export { FaqAccordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$accordionElements = $context.querySelectorAll('[data-faq-accordion="item"]');

    if ($$accordionElements.length > 0) {
        const $root = $$accordionElements[0].closest('.faq-accordion');

        for (let i = 0; i < $$accordionElements.length; i++) {
            const $accordionElement = new FaqAccordion($$accordionElements[i], {
                speed: 500,
                onlyOneActive: $root.getAttribute('data-faq-accordion-one-active') === '1',
                waitUntilClose: $root.getAttribute('data-faq-accordion-wait') === '1',
                scrollAddition: parseInt($root.getAttribute('data-faq-scroll-addition')) || 0,
                activeClass: 'is--active'
            });
            $accordionElement.initialize();
        }
    }
});
